import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import VueCryptojs from 'vue-cryptojs'

import router from './routes/index.js'  
import store from './store/index.js'

Vue.use(VueCryptojs)
Vue.config.productionTip = false

// import './assets/javascripts/kspay_web'

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
